export default __webpack_public_path__ + "static/media/ongoing.abdd06bc.svg";